export const fluidStyles = `
  height: 100%;
  width: 100%;
`;

export const meetTileFrameStyle = {
  width: '100%',
  height: '100%',
  minHeight: 180,
  borderRadius: 14,
  overflow: 'hidden',
  border: '1px solid rgba(255,255,255,0.14)',
  background: '#111827',
  boxShadow: '0 4px 18px rgba(0,0,0,0.25)',
};

export const profileTileStyle = {
  width: '100%',
  height: '100%',
  minHeight: 180,
  borderRadius: 14,
  border: '1px solid rgba(255,255,255,0.14)',
  background: 'linear-gradient(180deg, #1b2533 0%, #101820 100%)',
  color: '#ffffff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 9,
  boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.04)',
};

export const avatarStyle = {
  width: 68,
  height: 68,
  borderRadius: '50%',
  background: '#2a3a4b',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 22,
  fontWeight: 700,
};

export const filmstripProfileTileStyle = {
  width: '100%',
  height: '100%',
  background: '#1f2937',
  color: '#ffffff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
};

export const filmstripAvatarStyle = {
  width: 44,
  height: 44,
  borderRadius: '50%',
  background: '#374151',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 18,
  fontWeight: 700,
};

export const smallCardNameStripStyle = {
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(180deg, rgba(7, 23, 36, 0) 0%, rgba(7, 23, 36, 0.78) 100%)',
  color: '#fff',
  padding: '18px 10px 8px',
  fontSize: 11,
  fontWeight: 600,
  textShadow: '0 1px 2px rgba(0,0,0,0.45)',
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
